import { useState } from 'react'
import PropTypes from 'prop-types'

const BaseView = ({ onClose, steps }) => {
  const [currentStep, setCurrentStep] = useState(0)
  const handleNext = () => {
    setCurrentStep((prev) => prev + 1)
  }
  const handleBack = () => {
    if (!currentStep) {
      return onClose()
    }
    setCurrentStep((prev) => prev - 1)
  }

  const renderStep = () => {
    const { Component, config } = steps[currentStep]
    return <Component onNext={handleNext} onBack={handleBack} {...config} />
  }

  return renderStep()
}

BaseView.propTypes = {
  onClose: PropTypes.func,
  steps: PropTypes.array,
}

export default BaseView
